<template>
  <v-card>
    <v-card-title>
      <v-title>Scheduled Reports</v-title>
      <v-card-text>
        Use this form to manually run scheduled UB reports. The UB report will
        run using the parameters provided, and the update the production
        database
      </v-card-text>
    </v-card-title>
    <v-card-text>
      <v-tabs v-model="tab" background-color="primary">
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#margin">
          Margin Summary
        </v-tab>

        <v-tab href="#cost">
          Cost per Service
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item :key="1" value="margin">
          <v-card flat>
            <v-layout wrap>
              <v-flex xs3 sm3 md1>
                <v-card-text class="pt-4">
                  Statement
                </v-card-text>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="statement_number"
                  label="e.g. 701"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-alert
              :value="alertMargin"
              type="success"
              transition="scale-transition"
            >
              Success! 1 Report Saved
            </v-alert>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="2" value="cost">
          <v-card flat>
            <v-layout wrap>
              <v-flex xs3 sm3 md1>
                <v-card-text class="pt-4">
                  Statement
                </v-card-text>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="statement_number"
                  label="e.g. 701"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-alert
              :value="alertCost"
              type="success"
              transition="scale-transition"
            >
              Success! 1 Report Saved
            </v-alert>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <v-alert :value="alertError" type="error" transition="scale-transition">
        Oops! Something went wrong! Help us improve your experience by sending
        an error report
      </v-alert>
      <v-text-field
        class="pa-0"
        color="success"
        :loading="loading"
        disabled
      ></v-text-field>
      <v-btn @click="getReport(statement_number)" color="primary" large>
        Run Report
      </v-btn>
    </v-card-text>
  </v-card>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapUtilityActions } = createNamespacedHelpers(
  `orders/utility`
);
export default {
  name: 'scheduledReports',
  data() {
    return {
      tab: 'margin',
      statement_number: null,
      loading: false,
      alertMargin: false,
      alertCost: false,
      alertError: false,
    };
  },
  methods: {
    ...mapUtilityActions(['getMarginSummary', 'getCostPerService']),
    getReport(param) {
      const vm = this;
      vm.loading = true;
      if (vm.tab == 'margin') {
        vm.getMarginSummary(param).then(e => {
          vm.loading = false;
          if (e.success) {
            vm.alertMargin = true;
            setTimeout(() => (vm.alertMargin = false), 5000);
          } else {
            vm.alertError = true;
            setTimeout(() => (vm.alertError = false), 5000);
          }
        });
      } else {
        vm.getCostPerService().then(e => {
          vm.loading = false;
          if (e.success) {
            vm.alertCost = true;
            setTimeout(() => (vm.alertCost = false), 5000);
          } else {
            vm.alertError = true;
            setTimeout(() => (vm.alertError = false), 5000);
          }
        });
      }
    },
  },
};
</script>
